module.exports = __webpack_public_path__ + "img/u-line-long.94b04efd.svg";